






























































import { Notification } from "@/store/modules/notifications";
import { Component, Prop, Vue } from "vue-property-decorator";
import { AccomodationUnitTypesWithDetailsView } from "@/shared/models/accomodationUnitTypesWithDetailsView";
import { CategoriesEnum } from "@/shared/models/enums.type";

@Component
export default class AccomodationUnitTypeTile extends Vue {
  @Prop() unitType?: AccomodationUnitTypesWithDetailsView;

  update() {
    this.$emit("update", this.unitType);
  }

  askForRemove() {
    if (!this.unitType) return;

    const id = this.unitType.id;

    this.$store.dispatch("showNotification", {
      id: this.unitType.id,
      color: "warning",
      message: this.$t("AccomodationUnitType.DeleteConfirmation", {
        value: this.unitType.name,
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.$emit("remove", id);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  get category() {
    if (this.unitType) {
      if (this.unitType.categoryId === CategoriesEnum.Empty) {
        return 0;
      }
      return this.unitType.categoryId + 1;
    }
    return 0;
  }
}
